import _axios from "../api";
const API = {
  type: "notificationtemplate/type",
  add: "notificationtemplate/add",
  getList: "notificationtemplate/list",
  getById: (id) => `notificationtemplate/${id}`,
  update: "notificationtemplate/update",
  activeInactive: (id, value) => `notificationtemplate/active-inactive/${id}/${value}`
};

export const getNotificationTypeList = async () => {
  const response = await _axios.get(API.type);
  return response.data.data;
};

export const addNotificationTemplate = async (model) => {
  return _axios
    .post(API.add, model)
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};

export const getNotificationTemplateList = async (qry) => {
  const response = await _axios.get(`${API.getList}${qry}`);
  return response.data;
};

export const getNotificationtemplatebyId = async (id) => {
  const response = await _axios.get(API.getById(id));
  return response.data.data;
};

export const updateNotifitionTemplate = async (model) => {
  return await _axios
    .put(API.update, model)
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};

export const isActiveNotificationTemplate = async (id, value) => {
  const { data } = await _axios.patch(API.activeInactive(id, value));
  return data;
};
